export const iconFontAwesomeEmojiFaceGrinBeam = (
	<i className="fa-solid fa-face-grin-beam"></i>
);
